// extracted by mini-css-extract-plugin
module.exports = {"bluetooth":"Bluetooth_bluetooth__LMAfy"};